import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';
import { scrollToElement } from '@project/shared/utils/scroll-to/js/scroll-to';

const classes = {
	submitForm: 'js-form__button-event--submit',
	cancelForm: 'js-form__button-event--cancel',
	focusElement: 'js-form__event-show-additional-fields',
	additionalFields: 'js-form__additional-fields',
	// inputCountrySelector: 'js-form__input-select',
	stateFormContactAdditionalFieldsVisible: 'state-m-form-order--show-additional-fields',
	stateFormContactHiddenAfterSubmit: 'state-m-form-order-form--hidden-after-submit',
	stateFormBuilderError: 'input-validation-error', // set by Sitecore form builder. no js- prefix
	stateFormIsHidden: 'state-m-form-order--is-hidden',
};

@createModule('FormOrder')
/**
 * form-order module implementation.
 *
 * @author Robert Schork <robert.schork@namics.com>
 */
export class FormOrder extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		// TODO: clarify why this class is not in use
		// const cssClassSectionNoteAvailable = 'state-m-form-order--is-hidden';

		// TODO: name-syntax-error js selector requires js- prefix. has to be checked with backend
		const cssClassFormNotAvailable = 'm-form-order--is-hidden';

		// we have to check if the hidden class was set.
		// this is the case, when form-order is disabled for sitecore.
		if (this.$ctx.hasClass(cssClassFormNotAvailable)) {
			// if form order should not be displayed, whe also have
			// to hide the parent section container
			// NOTE: Sitecore can't set the related property on page level,
			// 		 so that the section would be hidden automatically
			this.$ctx.parent().addClass(classes.stateFormIsHidden);
		} else {
			// const $countrySelect = $(`.${classes.inputCountrySelector}`, $ctx);
			const $textareaWithFocus = $(`.${classes.focusElement}`, this.$ctx);
			const $areaAdditionalFields = $(`.${classes.additionalFields}`, this.$ctx);
			const $buttonCancel = $(`.${classes.cancelForm}`, this.$ctx);
			const $buttonSubmit = $(`.${classes.submitForm}`, this.$ctx);

			if ($textareaWithFocus.length > 0 && $areaAdditionalFields.length > 0) {
				$textareaWithFocus.on('focus', () => {
					$areaAdditionalFields.addClass(classes.stateFormContactAdditionalFieldsVisible);
					$(window).trigger('NavigationInPage:reInitNoClick');
				});
			}

			// check for cancel button placed from sitecore
			if ($buttonCancel.length !== 0) {
				// close the additional form field section
				$buttonCancel.on('click', (ev: Event) => {
					$areaAdditionalFields.removeClass(classes.stateFormContactAdditionalFieldsVisible);
					scrollToElement(this.$ctx, true, $(window).height() / 10);
					$(window).trigger('NavigationInPage:reInitNoClick');
				});
			}

			if ($buttonSubmit.length !== 0) {
				$buttonSubmit.on('click', (ev: Event) => {
					this.$ctx.addClass(classes.stateFormContactHiddenAfterSubmit);
					const $elm =
						$(`.${classes.stateFormBuilderError}`, this.$ctx).length > 0
							? $(`.${classes.stateFormBuilderError}`, this.$ctx)
							: this.$ctx;
					scrollToElement($elm, true, $(window).height() / 10);
					$(window).trigger('NavigationInPage:reInitNoClick');
				});
			}
		}

		resolve();
	}

	stop() {}

	_triggerChangeEvent() {
		triggerPublicEvent(PublicEvents.uxChange, this, this._ctx);
	}
}
